import util from '@bmp-vue/core/api/util'

const controller = 'ContaOperadores'
export default Object.assign({}, util.GetCrud(controller, null), {
  ListarPorConta: function (dto) {
    return util.Axios.GetAll(controller + '/ListarPorConta', dto)
  },
})
